/**
 * Utilidades para manejar APIs del DOM de forma segura en diferentes entornos
 */

// Verificar si estamos en el navegador
export const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

// Verificar si HTMLElement está disponible
export const isHTMLElementAvailable = typeof HTMLElement !== 'undefined';

// Obtener window de forma segura
export const getWindow = (): Window | undefined => {
  return typeof window !== 'undefined' ? window : undefined;
};

// Obtener document de forma segura
export const getDocument = (): Document | undefined => {
  return typeof document !== 'undefined' ? document : undefined;
};

// Obtener localStorage de forma segura
export const getLocalStorage = (): Storage | null => {
  if (!isBrowser) return null;
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
};

// Crear un HTMLElement de forma segura
export const createHTMLElement = (tagName: string): HTMLElement | null => {
  if (!isBrowser || !isHTMLElementAvailable) return null;
  try {
    return document.createElement(tagName);
  } catch (e) {
    return null;
  }
};

// Verificar si un elemento es HTMLElement
export const isHTMLElement = (element: any): element is HTMLElement => {
  return isHTMLElementAvailable && element instanceof HTMLElement;
};

// Función para ejecutar código solo en el navegador
export const runInBrowser = (callback: () => void): void => {
  if (isBrowser) {
    callback();
  }
};

// Función para ejecutar código después de que el DOM esté listo
export const onDOMReady = (callback: () => void): void => {
  if (!isBrowser) return;
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}; 